import { UserRoleCodes } from '@/types'

import { checkRights } from '@/helpers'

export default [
  {
    path: 'header-and-footer/footer',
    name: 'manager-header-and-footer-footer',
    component: () =>
      import(
        '../../../views/Manager/HeaderAndFooter/ManagerHeaderAndFooterFooter.vue'
      ),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'header-and-footer/menu',
    name: 'manager-header-and-footer-menu',
    component: () =>
      import(
        '../../../views/Manager/HeaderAndFooter/ManagerHeaderAndFooterMenu.vue'
      ),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'header-and-footer/search',
    name: 'manager-header-and-footer-search',
    component: () =>
      import(
        '../../../views/Manager/HeaderAndFooter/ManagerHeaderAndFooterSearch.vue'
      ),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'header-and-footer/account',
    name: 'manager-header-and-footer-account',
    component: () =>
      import(
        '../../../views/Manager/HeaderAndFooter/ManagerHeaderAndFooterAccount.vue'
      ),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
]
